var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 14.3783C16.5 16.3055 15.1803 17.6148 13 17.9277V18.5C13 19.0523 12.5523 19.5 12 19.5C11.4477 19.5 11 19.0523 11 18.5V17.9433C9.19828 17.7185 8.00128 16.8468 7.61311 15.7143C7.54039 15.5211 7.5 15.3119 7.5 15.1187C7.5 14.5392 7.87163 14.169 8.42101 14.169C8.88151 14.169 9.17235 14.3541 9.39856 14.8209C9.76212 15.827 10.7639 16.2777 12.0081 16.2777C13.4138 16.2777 14.3995 15.5855 14.3995 14.6197C14.3995 13.7827 13.8178 13.2676 12.2989 12.9537L11.0467 12.6962C8.71185 12.2213 7.62118 11.1268 7.62118 9.42857C7.62118 7.6514 8.98278 6.37299 11 6.06928V5.5C11 4.94772 11.4477 4.5 12 4.5C12.5523 4.5 13 4.94772 13 5.5V6.08483C14.5435 6.34476 15.6958 7.19 16.088 8.45473C16.1364 8.5835 16.1607 8.73642 16.1607 8.92958C16.1607 9.43662 15.7971 9.7827 15.2558 9.7827C14.7711 9.7827 14.4722 9.57344 14.254 9.12274C13.8582 8.14085 13.026 7.72233 11.9354 7.72233C10.6427 7.72233 9.72172 8.334 9.72172 9.30785C9.72172 10.0966 10.3034 10.6036 11.7576 10.9095L13.0099 11.167C15.4659 11.674 16.5 12.6559 16.5 14.3783Z",
    fill: "currentColor"
  })));
}

export default SvgPaid;